<script>
export default {
  props: {
    textInputArray: Array,
    selectInputArray: Array,
    textInputNumberArray: Array,
    province: Boolean,
    showSearch: Boolean,
    radioInputArray: Array,
    checkboxInputArray: Array,
    initData: Object
  },
  data() {
    const textInout = this.textInputArray || [];
    const selectInput = this.selectInputArray || [];
    const radioInput = this.radioInputArray || [];
    const checkboxInput = this.checkboxInputArray || [];
    const textInputNumber = this.textInputNumberArray || [];
    const ceraterForm = textInout
      .concat(selectInput)
      .concat(radioInput)
      .concat(checkboxInput)
      .concat(textInputNumber);
    const formData = {};
    ceraterForm.forEach(o => {
      if (this.initData && this.initData[o.keyName]) {
        formData[o.keyName] = this.initData[o.keyName];
      } else if (o.value) {
        formData[o.keyName] = o.value;
      } else {
        formData[o.keyName] = undefined;
      }
    });
    return {
      formData
    };
  },
  methods: {
    onSubmit() {
      this.$emit("onSearch", this.formData);
    },
    onChange(key) {
      if (key === "districtProvince") {
        this.formData.districtCity = null;
      }
      this.$emit("onChange", this.formData);
    },
    onSelectValue(refName, value) {
      if (value === false && this.$refs[refName]) {
        const refObj = this.$refs[refName][0];
        refObj.blur();
      }
    }
  }
};
</script>

<template>
  <el-form :model="formData" class="demo-form-inline searchForm" size="small">
    <el-form-item
      v-for="item in textInputArray"
      :key="item.keyName"
      :label="item.label"
      @keyup.enter.native="onSubmit"
      class="labelStyle"
    >
      <el-input
        v-model="formData[item.keyName]"
        @change="onChange(item.keyName)"
        class="labelInput"
        clearable
        :placeholder="item.label"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-for="item in selectInputArray"
      class="labelStyle"
      :label="item.label"
      :key="item.keyName"
    >
      <el-select
        v-if="item.children && item.children.length > 0"
        v-model="formData[item.keyName]"
        class="labelInput"
        placeholder="请选择"
        @change="onChange(item.keyName)"
        @visible-change="(value) => onSelectValue(item.keyName, value)"
        filterable
        clearable
        :ref="item.keyName"
      >
        <el-option
          v-for="child in item.children"
          :key="child.keyName"
          :label="child.label"
          :value="child.keyName"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-for="item in radioInputArray"
      class="radioStyle"
      :label="item.label"
      :key="item.keyName"
    >
      <el-radio-group
        v-if="item.children && item.children.length > 0"
        v-model="formData[item.keyName]"
        class="childrenItem"
        placeholder="请选择"
        @change="onChange"
      >
        <el-radio
          v-for="child in item.children"
          :key="child.keyName"
          :label="child.keyName"
          :value="child.keyName"
        >{{child.label}}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-for="item in checkboxInputArray" class="checkboxStyle" :key="item.keyName">
      <el-checkbox
        class="childrenItem"
        v-model="formData[item.keyName]"
        @change="onChange(item.keyName)"
      >{{item.label}}</el-checkbox>
    </el-form-item>
    <el-form-item
      v-for="item in textInputNumberArray"
      :key="item.keyName"
      :label="item.label"
      class="labelStyle"
    >
      <el-input-number
        v-model="formData[item.keyName]"
        @change="onChange(item.keyName)"
        class="labelInputNumber"
        clearable
        :controls="false"
        placeholder="请输入"
      ></el-input-number>
    </el-form-item>
    <el-form-item v-if="showSearch">
      <elementButton size="mini" class="searchButton" @click="onSubmit">搜索</elementButton>
    </el-form-item>
  </el-form>
</template>

<style lang="scss">
.searchForm {
  border: 1px;
  margin: 0 2%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #00c1de;
    background-color: #fff;
  }

  .el-radio__inner::after {
    background-color: #00c1de;
  }

  .el-radio__input.is-checked + .el-radio__label {
    color: #00c1de;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #00c1de;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #00c1de;
    background-color: #00c1de;
  }
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #00c1de;
  }
  .el-select-dropdown__item.hover {
    color: #00c1de;
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #00c1de;
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:hover {
    border-color: #00c1de;
  }

  .labelStyle {
    margin: 23px 10px;
    width: auto;
    display: flex;
  }
  .checkboxStyle {
    margin: 23px 10px;
    width: auto;
    display: flex;
  }
  .labelInput {
    width: 130px;
  }
  .labelInputNumber {
    width: 110px;
  }

  .searchButton {
    margin: 22px 10px;
    font-size: 14px;
    background: rgba(0, 193, 222, 1);
    border-color: #00c1de;
    height: 35px;
    // width: 40px;
  }
  .radioStyle {
    margin: 25px 10px;
    font-size: 14px;
    width: 300px;
    .childrenItem {
      min-width: 220px;
      .el-radio {
        margin-right: 10px;
      }
    }
  }
}
.el-select-dropdown__item.selected {
  color: #00c1de;
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/searchForm.vue